import { cn } from "@/lib/utils";

const MAP = {
  new: { label: "NEW", cls: "bg-[hsl(var(--brand))] text-white" },
  used: { label: "USED", cls: "bg-[hsl(var(--action))] text-white" },
  spare: { label: "SPARE PART", cls: "bg-[hsl(var(--charcoal))] text-white" },
};

export function ListingTypeBadge({ type, className }) {
  const s = MAP[type] || MAP.used;
  return (
    <span
      data-testid={`listing-type-badge-${type}`}
      className={cn(
        "inline-flex items-center rounded-md px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider",
        s.cls,
        className
      )}
    >
      {s.label}
    </span>
  );
}
